<template>
  <div>
    <!-- <img class="loader" src="@/assets/imgs/loading2.gif" alt="loader" /> -->
    <v-progress-circular
      :size="100"
      color="primary"
      indeterminate
      class="loader"
    ></v-progress-circular>
  </div>
</template>

<script>
export default {
  name: "loader"
};
</script>

<style scoped>
.loader {
  display: block;
  width: 20%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 90%);
}
</style>
